module.exports = __webpack_public_path__ + "img/Nuri.a9f6dc88.png";